import styled, { keyframes, css } from "styled-components";

// Arrow Animations
const floatUp = keyframes`
  0% { transform: translateY(4px) scale(0.9); opacity: 0.7; }
  50% { transform: translateY(-2px) scale(1.05); opacity: 1; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
`;

const floatDown = keyframes`
  0% { transform: translateY(-4px) scale(0.9); opacity: 0.7; }
  50% { transform: translateY(2px) scale(1.05); opacity: 1; }
  100% { transform: translateY(0) scale(1); opacity: 1; }
`;

export const MainWrapper = styled.div`
  display: flex;
  gap: 10px;
  background-color: #fff;
  font-family: 'Inter', sans-serif;
  margin-left: -25px;

  /* Stack columns on tablet and mobile */
  @media (max-width: 1024px) {
    flex-direction: row;
    margin-left: 0;
    padding: 10px;
    gap: 10px;
  }

  @media (max-width: 768px) {
    padding: 0;
    flex-direction: column;
    gap: 0;
  }
`;

export const Container = styled.div`
  width: 625px;
  flex-shrink: 0; /* Prevents shrinking on desktop */
  border-radius: 18px;
  background: #1A1A1A;
  padding: 36px 24px 24px 24px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  color: #E0E0E0;

  @media (max-width: 1024px) {
    width: 100%; /* Full width on tablet/mobile */
  }
  
  @media (max-width: 768px) {
    padding: 24px 10px 0 10px; /* Reduce padding on mobile */
    border-radius: 0; /* Remove radius when full-width */
  }
`;

export const Title = styled.h2`
  margin-bottom: 24px;
  font-size: 28px;
  font-weight: 700;
  color: #fff;

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 20px;
  }
`;

export const Tabs = styled.div`
  display: flex;
  gap: 15px;
  margin-bottom: 28px;

  /* Allow horizontal scrolling for tabs on small screens */
  @media (max-width: 768px) {
    overflow-x: auto;
    padding-bottom: 5px;

    /* Hide scrollbar */
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
  }
`;

export const Tab = styled.button`
  font-size: 15px;
  background: ${({ active }) => active ? 'linear-gradient(135deg, #FFD8A8, #FFAD60)' : 'transparent'};
  border: none;
  border-radius: 20px;
  color: ${({ active }) => active ? '#1A1A1A' : '#999'};
  padding: 8px 20px;
  font-weight: ${({ active }) => active ? 700 : 500};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  white-space: nowrap; /* Prevent tab text from wrapping */

  &:hover {
    background: ${({ active }) => active ? 'linear-gradient(135deg, #FFD8A8, #FFAD60)' : '#2e2e2e'};
    color: #fff;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    padding: 6px 16px;
  }
`;

// Bid Section Styles
export const BidSectionContainer = styled.div`
  flex: 1; /* Takes remaining space on desktop */
  border-radius: 18px;
  background: #1A1A1A;
  padding: 36px 24px 24px 24px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.2);
  color: #E0E0E0;

  @media (max-width: 1024px) {
    width: 100%; /* Full width on tablet/mobile */
  }

  @media (max-width: 768px) {
    padding: 24px 15px; /* Reduce padding on mobile */
    border-radius: 0;
  }
    @media (max-width: 768px) {
  font-size: 13px;

}
  @media (max-width: 480px) {
    padding: 0px; /* Reduce padding on mobile */
    border-radius: 0;
  }

`;

export const BidsTitle = styled.h3`
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 24px;
  color: #fff;

  @media (max-width: 768px) {
    font-size: 20px;
  }
    @media (max-width: 480px) {
    font-size: 15px;
    padding: 0 10px;
  }
`;

export const BidsTabs = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 24px;

  /* Allow horizontal scrolling for tabs on small screens */
  @media (max-width: 768px) {
    overflow-x: auto;
    padding-bottom: 5px;
    
    /* Hide scrollbar */
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
`;

export const BidsTab = styled.button`
  background: ${({ active, type }) => {
    if (active) return type === 'bullish' ? 'linear-gradient(135deg, #B2F2BB, #8EE4AF)' : 'linear-gradient(45deg, #FF6B6B, #F05454)';
    return '#282828';
  }};
  color: ${({ active }) => active ? '#1A1A1A' : '#999'};
  border: none;
  border-radius: 20px;
  padding: 10px 18px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  white-space: nowrap; /* Prevent tab text from wrapping */
  
  &:hover { filter: brightness(1.2); }
`;

export const BidList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 10px 10px;
`;

export const BidCard = styled.div`
  background: #282828;
  border-radius: 12px;
  padding: 18px;
  border-left: 5px solid ${({ isBullish }) => isBullish ? '#8EE4AF' : '#FF6B6B'};
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  transition: transform 0.2s ease-in-out;
  &:hover { transform: translateY(-4px); }

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

export const BidHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap; /* Allow wrapping on small screens */
  gap: 10px;
`;

export const BidInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const BidCode = styled.span`
  font-size: 14px;
  color: #888;
  font-weight: 500;
`;

export const StocksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  row-gap: 10px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr); /* keep 3 per row */
    gap: 4px;
    row-gap: 2px;
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 4px;
    row-gap: 2px;
  }
`;



export const StockItem = styled.span`
  font-size: 12px;
  background: ${({ isBigBull, isBigBear }) => {
    if (isBigBull) return 'linear-gradient(135deg, #B2F2BB, #8EE4AF)';
    if (isBigBear) return 'linear-gradient(135deg, #FFB3B3, #FF6F61)';
    return '#333';
  }};
  color: ${({ isBigBull, isBigBear }) => (isBigBull || isBigBear) ? '#222c21' : '#E0E0E0'};
  padding: 8px 10px;
  border-radius: 8px;
  text-align: center;
  font-weight: 600;
  @media (max-width: 480px) {
  font-size: 8px;
  }
`;

export const Arrow = styled.span`
  display: inline-block;
  margin-left: 6px;
  font-size: 14px;
  font-weight: 900;
  text-shadow: 0 1px 1px rgba(0,0,0,0.3);

  ${({ up }) =>
    up
      ? css`color: #4caf50; animation: ${floatUp} 0.5s ease-out;`
      : css`color: #ff3b3b; animation: ${floatDown} 0.5s ease-out;`}
`;

export const Dot = styled.span`
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
  background-color: ${(props) =>
    props.selectionType === "BULLISH" ? "green" : "red"};
`;

export const BidFooter = styled.div`
  font-size: 13px;
  color: #888;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  margin-top:10px;
  flex-wrap: wrap; /* Allow wrapping */
  gap: 8px;

  /* Stack footer items on small mobile */
  @media (max-width: 480px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PointsText = styled.div`
    font-size: 15px;
    color: #e0e0e0;
    font-weight: 600;
`;

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 250px; /* adjust based on your layout */
`;

const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoaderCircle = styled.div`
  width: 45px;
  height: 45px;
  border: 5px solid #2b2b2b;
  border-top: 5px solid #4aa3ff;
  border-radius: 50%;
  animation: ${spinAnimation} 0.8s linear infinite;
`;

// Table container for scroll and responsiveness
export const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto; /* This is key for table responsiveness */
  margin-bottom: 24px;
`;

// Leaderboard Table
export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 12px; // Adds spacing between rows for modern look
  background: transparent;
  min-width: 500px; /* Ensure table has a min-width to force scroll */
`;

// Table Headers
export const Th = styled.th`
  font-size: 14px;
  color: #ccc;
  font-weight: 700;
  text-align: left;
  padding: 12px 24px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: ${({ minWidth }) => minWidth || 'auto'};
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 13px;
    padding: 10px 15px;
  }
    @media (max-width: 480px) {
    font-size: 10px;
    padding: 3px 5px;
  }
`;

// Table Rows
export const Tr = styled.tr`
  background: ${({ isSelected }) => (isSelected ? '#334237' : '#1f1f1f')};
  color: ${({ isSelected }) => (isSelected ? '#A9F1B2' : '#E0E0E0')};
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2); // subtle shadow for depth
  transition: all 0.25s ease-in-out;

  &:hover {
    background: ${({ isSelected }) => (isSelected ? '#334237' : '#2a2a2a')};
    transform: translateY(-2px); // smooth lift on hover
  }
`;

// Table Data Cells
export const Td = styled.td`
  font-size: 15px;
  padding: 12px 8px;
  border: none;
  text-align: left;

  &:first-child {
    width: 40px;
    text-align: center;
    font-weight: 700;
    padding-left: 15px;
  }

  &:nth-child(2) {
    max-width: 120px;       /* Limit column width */
    font-weight: 600;
    color: #fff;
    white-space: nowrap;    /* Prevent wrapping */
    overflow: hidden;       /* Hide overflow text */
    text-overflow: ellipsis; /* Show ... for long names */
  }

  &:nth-child(3),
  &:nth-child(4),
  &:nth-child(5) {
    text-align: center;
    white-space: nowrap;
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
    padding: 10px 6px;
    
    &:first-child {
      padding-left: 10px;
    }
  }
    @media (max-width: 480px) {
    font-size: 10px;
    padding: 5px 7px;
    text-align: left;
    &:nth-child(2) {
    max-width: 40px;}
    &:nth-child(3),
  &:nth-child(4),
  &:nth-child(5) {
    text-align: left;
    white-space: nowrap;
  }
  
  }
`;


// Smooth hover highlight for table
export const HoverEffect = css`
  &:hover {
    background: #2e2e2e;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  }
`;

// Title style (Bullish / Bearish header)
export const GroupTitle = styled.h4`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 10px 0 8px;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.25);
  ${({ type }) =>
    type === "BULLISH"
      ? css`
          color: #4caf50;
        `
      : css`
          color: #ff3b3b;
        `}
`;

export const StocksGridWrapper = styled.div`
  margin-top: 10px;
`;
export const BackArrow = styled.button`
  background: none;
  border: none;
  color: #ffad60;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: 0.2s ease-in-out;

  &:hover {
    color: #ffd8a8;
  }
    @media (max-width: 480px) {
    font-size: 12px;
  font-weight: 600;
  }
`;
